<template>
    <v-container class="confirmation-requirements">

        <h2>Confirmation Requirements</h2>

        <v-checkbox
            v-model="localPickupPhoto"
            label="Photo required for Pickup"
            hideDetails
        />

        <v-checkbox
            v-model="localDeliveryPhoto"
            label="Photo required for Delivery"
            hideDetails
        />

        <ClButton
            aria-label="Update Confirmation Requirement Settings"
            class="button-update"
            :rounded="false"
            @click="updateSettings()"
        >
            Update Confirmation Requirements
        </ClButton>
    </v-container>
</template>

<script>
// Vuex
import { mapState } from 'vuex';

export default {
    name: 'ConfirmationRequirements',
    data() {
        return {
            localPickupPhoto: null,
            localDeliveryPhoto: null,
        };
    },
    computed: {
        ...mapState( {
            requirements: ( state ) => state.Mail.Settings.requirements,
            pickupPhoto: ( state ) => state.Mail.Settings.requirements.pickupPhoto,
            deliveryPhoto: ( state ) => state.Mail.Settings.requirements.deliveryPhoto,
        } ),
    },
    watch: {
        pickupPhoto: {
            immediate: true,
            handler() {
                this.localPickupPhoto = this.pickupPhoto;
            },
        },
        deliveryPhoto: {
            immediate: true,
            handler() {
                this.localDeliveryPhoto = this.deliveryPhoto;
            },
        },
    },
    methods: {
        async updateSettings() {
            await this.$store.dispatch( 'Mail/Settings/update', {
                pickupPhotoRequired: this.localPickupPhoto,
                deliveryPhotoRequired: this.localDeliveryPhoto,
            } );
        },
    },
};
</script>

<style scoped lang="scss">
.confirmation-requirements {
    .button-update {
        margin-top: 1rem;
        width: 100%;
    }
}
@include mixins-above(tablet) {
    .confirmation-requirements {
        .button-update {
            width: auto;
        }
    }
}
</style>
